import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "./Login.scss";
import "react-toastify/dist/ReactToastify.css";
import img1 from "../../assets/Login/5243321.jpg";

const SignIn = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const token = localStorage.getItem("raer_token");
  const [otpSent, setOtpSent] = useState(false);

  useEffect(() => {
    console.log(token);
    if (token) {
      navigate("/");
    } else {
      navigate("/login");
    }
  }, []);

  const [formField, setFormFields] = useState({
    phone: "",
    otp: "",
    rememberMe: false,
  });

  const handleChangeFormField = (e) => {
    const { name, value, type, checked } = e.target;
    setFormFields({
      ...formField,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleCheckBox = (e) => {
    setFormFields({
      ...formField,
      rememberMe: e.target.checked,
    });
  };

  const LoginSendOtp = async (event) => {
    // setOtpSent(true);
    if (formField.phone.length !== 10) {
      toast.warn("Enter 10 digit Number", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }

    const config = {
      url: process.env.REACT_APP_BASE_URL + "auth/sendOtp",
      method: "post",
      data: {
        phone: formField.phone,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response?.data?.status == true) {
          setOtpSent(true);
          toast.success("OPT send successfully", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
          // setProducts(response?.data?.data?.products);
          // setCartProduct(response?.data?.data?.resultOfData);
          // setTotalPrice(response?.data?.data?.totalPrice);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
    event.preventDefault();
  };

  const onLogin = async (event) => {
    event.preventDefault();

    if (formField.otp === null || formField.otp === "") {
      toast.warn("Please enter the OTP.", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }

    const config = {
      url: process.env.REACT_APP_BASE_URL + "auth/login",
      method: "post",
      data: {
        phone: formField.phone,
        otp: formField.otp,
        rememberMe: formField.rememberMe,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          localStorage.setItem("raer_token", response?.data?.data?.token);
          console.log("->>>.", response?.data?.data?._id);
          localStorage.setItem("raer_id", response?.data?.data?._id);
          localStorage.setItem("raerAcess", response?.data?.data?.raerAcces);
          // navigate("/");
          const redirectUrl = localStorage.getItem("redirectAfterLogin");

          if (redirectUrl) {
            localStorage.removeItem("redirectAfterLogin");
            navigate(redirectUrl);
            window.scroll({
              top: 0,
              behavior: "smooth",
            });
          } else {
            navigate("/"); // default redirect if no saved URL
            window.scroll({
              top: 0,
              behavior: "smooth",
            });
          }
        }

        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            toast.error("Problem with data fetching.", {
              position: "bottom-right",
              autoClose: 4000,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
            });
          } else if (response?.data?.response_code == 404) {
            toast.error("Problem with data fetching.", {
              position: "bottom-right",
              autoClose: 4000,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
            });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          toast.error("Your token is expired. Please login again.", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
        } else {
          toast.warn(
            "The OTP you entered is invalid. Please check and re-enter.",
            {
              position: "bottom-right",
              autoClose: 4000,
              pauseOnHover: true,
              draggable: true,
              theme: "light",
            }
          );
        }
      });
  };

  return (
    <>
      <div className="second-form">
        <div className="second-inner">
          <div className="left-img">
            <img src={img1} alt="" />
          </div>

          <div className="right-form">
            <h2 className="text-center">LogIn/SignUp</h2>

            <form className="form-main-div">
              {!otpSent ? (
                <div className="form-div div-1">
                  <input
                    type="number"
                    name="phone"
                    required
                    value={formField.phone}
                    placeholder="Enter Your Phone Number"
                    onChange={handleChangeFormField}
                  />
                  <button onClick={LoginSendOtp}>Get OTP</button>
                </div>
              ) : (
                <>
                  <div className="form-div inner11">
                    <input
                      type="number"
                      name="otp"
                      required
                      value={formField.otp}
                      placeholder="Enter Your OTP"
                      onChange={handleChangeFormField}
                    />
                  </div>

                  <div className="check-div inner11">
                    <label className="checkbox" htmlFor="checkbox">
                      <input
                        type="checkbox"
                        id="checkbox"
                        value="checkbox"
                        onChange={handleCheckBox}
                      />
                      &nbsp; Remember Me
                    </label>
                    <button className="resendOtp" onClick={LoginSendOtp}>
                      Resend OTP
                    </button>
                  </div>

                  <div className="login-div inner11">
                    <button onClick={onLogin}>LogIn</button>
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
        {/* <ToastContainer /> */}
      </div>
    </>
  );
};

export default SignIn;
